<template>
  <!-- Nuova password dal link ricevuto: la stessa scena dell'accesso
       (_auth.scss), campi con l'occhio come nel login -->
  <div class="auth">
    <aside class="auth__brand">
      <b-img
        class="auth__logo"
        :src="require(`@/assets/${$root.scope}/logo_area_pubblica_reg.png`)"
        :alt="$t('RecoverPassword.logo_alt')"
      ></b-img>
    </aside>

    <main class="auth__panel">
      <div class="auth__card">
        <router-link class="back-link" :to="{ name: 'LoginPage' }">
          <b-icon icon="arrow-left" aria-hidden="true"></b-icon>
          {{ $t('torna_login') }}
        </router-link>
        <h1 class="auth__title">{{ $t('reimposta_password_titolo') }}</h1>
        <p class="auth__lead">
          {{ $t('reimposta_password_descrizione_1') }}
          <span
            v-b-tooltip
            :title="$t('tooltip_password_special_chars')"
            >{{ $t('reimposta_password_carattere_speciale') }}</span
          >.
          {{ $t('reimposta_password_descrizione_2', { count: config.passwordHistoryDepth }) }}
        </p>

        <b-form @submit.prevent="OnSubmit">
          <b-form-group :label="$t('password')" label-for="reset-password">
            <div class="auth__field">
              <b-form-input
                id="reset-password"
                class="pr-5"
                name="password"
                :type="passwordClear ? 'text' : 'password'"
                v-model="form.password"
                :placeholder="$t('placeholder_nuova_password')"
                autocomplete="new-password"
                :state="form.password == null ? null : validatePassword"
                required
              ></b-form-input>
              <b-icon
                :icon="passwordClear ? 'eye' : 'eye-slash'"
                font-scale="1.2"
                class="auth__eye"
                role="button"
                tabindex="0"
                :aria-label="passwordClear ? $t('RecoverPassword.hide_password') : $t('RecoverPassword.show_password')"
                @click="passwordClear = !passwordClear"
                @keydown.enter.prevent="passwordClear = !passwordClear"
                @keydown.space.prevent="passwordClear = !passwordClear"
              ></b-icon>
            </div>
          </b-form-group>

          <b-form-group :label="$t('conferma_password')" label-for="reset-password-conferma">
            <div class="auth__field">
              <b-form-input
                id="reset-password-conferma"
                class="pr-5"
                name="password_confirmation"
                :type="passwordConfirmClear ? 'text' : 'password'"
                v-model="form.password_confirmation"
                :placeholder="$t('placeholder_conferma_password')"
                autocomplete="new-password"
                :state="form.password == null ? null : validateConfirm"
                required
              ></b-form-input>
              <b-icon
                :icon="passwordConfirmClear ? 'eye' : 'eye-slash'"
                font-scale="1.2"
                class="auth__eye"
                role="button"
                tabindex="0"
                :aria-label="passwordConfirmClear ? $t('RecoverPassword.hide_password') : $t('RecoverPassword.show_password')"
                @click="passwordConfirmClear = !passwordConfirmClear"
                @keydown.enter.prevent="passwordConfirmClear = !passwordConfirmClear"
                @keydown.space.prevent="passwordConfirmClear = !passwordConfirmClear"
              ></b-icon>
            </div>
          </b-form-group>

          <p v-if="status.loggedIn == false" class="auth__error" role="alert">
            {{ $t('credenziali_errate') }}
          </p>

          <div class="auth__actions">
            <b-button
              type="submit"
              :disabled="cantSubmit"
              variant="secondary"
              block
            >
              {{ $t('salva_nuova_password') }}
            </b-button>
          </div>
        </b-form>
      </div>
    </main>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import config from "@/_config/config";
export default {
  name: "RecoverPassword",
  data() {
    return {
      form: {
        username: this.$route.query.username,
        password: null,
        password_confirmation: null,
        token: this.$route.query.token,
      },
      has_minimum_lenth: true,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      passwordClear: false,
      passwordConfirmClear: false,
    };
  },
  computed: {
    config() {
      return config;
    },
    validatePassword() {
      if (this.form.password) {
        this.has_minimum_lenth = this.form.password.length >= 8;
        this.has_number = /\d/.test(this.form.password);
        this.has_lowercase = /[a-z]/.test(this.form.password);
        this.has_uppercase = /[A-Z]/.test(this.form.password);
        this.has_special = /[^\p{L}\p{N}\s]/u.test(this.form.password);
        return (
          this.has_minimum_lenth &&
          this.has_number &&
          this.has_lowercase &&
          this.has_uppercase &&
          this.has_special
        );
      }
      return false;
    },
    validateConfirm() {
      if (this.form.password) {
        return this.form.password_confirmation === this.form.password;
      }
      return false;
    },
    cantSubmit() {
      if (this.form.password && this.form.password_confirmation) {
        return this.form.password_confirmation !== this.form.password;
      }
      return true;
    },

    ...mapState("utente", ["status", "user"]),
  },
  methods: {
    ...mapActions("utente", ["resetPassword"]),
    OnSubmit() {
      // console.log(this.form);
      if (this.form) {
        this.resetPassword(this.form)
          .then((res) => {
            // console.log("after login ok", res);
          })
          .catch((error) => {
            // console.log("after login error", error);
          });
      }
    },
  },
};
</script>
